<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> removed the channel named-->
<!--        <strong>{{ $_.get(activity, "payload.name") }} </strong>.-->
        <span v-html="$t('notification.channelRemoved', { channel: $_.get(activity, 'payload.name'), agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChannelRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
